import { useState, useEffect } from "react";
import axios from "axios";
import PublicLayout from "@/components/layout/PublicLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DatenschutzPage() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await axios.get(`${API}/public/pages/datenschutz`);
        setPage(response.data);
      } catch (error) {
        console.error("Error fetching page:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, []);

  const defaultContent = `
    <h1>Datenschutzerklärung</h1>
    <h2>1. Datenschutz auf einen Blick</h2>
    <h3>Allgemeine Hinweise</h3>
    <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.</p>
    
    <h2>2. Datenerfassung auf dieser Website</h2>
    <p><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
    <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.</p>
    
    <h2>3. Ihre Rechte</h2>
    <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten Daten.</p>
    
    <h2>4. Affiliate-Hinweis</h2>
    <p>Diese Website enthält Affiliate-Links. Bei Abschluss eines Vertrags erhalten wir eine Provision.</p>
  `;

  return (
    <PublicLayout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          {loading ? (
            <div className="animate-pulse space-y-4">
              <div className="h-10 w-1/3 bg-slate-200 rounded"></div>
              <div className="h-4 w-full bg-slate-200 rounded"></div>
              <div className="h-4 w-2/3 bg-slate-200 rounded"></div>
            </div>
          ) : (
            <div 
              className="prose prose-slate max-w-none"
              dangerouslySetInnerHTML={{ __html: page?.content || defaultContent }}
            />
          )}
        </div>
      </div>
    </PublicLayout>
  );
}
